<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
      [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
      style="margin-right: 10px; cursor: pointer;"
      (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>
<div class="modal-body" [hidden]="minimise">
  <table class="table table-bordered form-inline custom-table">
    <tbody>
      <tr>
        <td><strong>HO LEID</strong></td><td>{{ rowData.HO_LEID }}</td>
        <td><strong>LEID</strong></td><td>{{ rowData.LEID }}</td>
        <td><strong>Tax Code</strong></td><td>{{ rowData.CDR_NO }}</td>
      </tr>
      <tr>
        <td><strong>ME Code</strong></td><td>{{ rowData.ME_CODE }}</td>
        <td><strong>Gross Inc/Exp</strong></td><td>{{ rowData.GIE_NAME }}</td>
        <td><strong>ORG AMT</strong></td><td>{{ rowData.ORG_AMT }}</td>
      </tr>
    </tbody>
  </table>

  <div style="margin: 8px 0;">
    <i class="fa fa-plus-circle color-green" style="font-size:24px;cursor:pointer;" (click)="addRow()"></i>
  </div>
  <table class="table table-bordered custom-table">
    <thead>
      <tr>
        <th></th>
        <th>Basket</th>
        <th>FDII</th>
        <th>Amount</th>
      </tr>
    </thead>
    <tbody>
      @for (t of QARList; track $index) {
<tr>
        <td>
          <i class="fa fa-minus-circle color-red" style="font-size:20px;cursor:pointer;" (click)="deleteRow(t)"></i>
        </td>
        <td>
          <select class="form-control" [ngModel]="t.SOURCE_KEY" (ngModelChange)="t.SOURCE_KEY=$event">
            @for (s of basketDetails; track $index) {
<option [ngValue]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
          </select>
        </td>
        <td>
          <select class="form-control" [ngModel]="t.FDII_KEY" (ngModelChange)="t.FDII_KEY=$event">
            @for (s of fdiiDetails; track $index) {
<option [ngValue]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
          </select>
        </td>
        <td>
          <input class="form-control" [ngModel]="t.ADJ_AMT" (ngModelChange)="t.ADJ_AMT=$event; updateTotal()">
        </td>
      </tr>
}
      <tr>
        <td colspan="3"><strong>Total</strong></td>
        <td><strong>{{ total }}</strong></td>
      </tr>
    </tbody>
  </table>
</div>
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button" type="button" (click)="reset()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
